var React = require('react');

function Link (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M34.497 13.5H37.5a10.5 10.5 0 010 21h-3.003a10.443 10.443 0 01-7.782-3.503 1.5 1.5 0 112.242-1.994A7.443 7.443 0 0034.5 31.5h3a7.5 7.5 0 000-15h-2.998a7.437 7.437 0 00-5.545 2.497 1.5 1.5 0 11-2.242-1.994 10.438 10.438 0 017.782-3.503zM3.075 16.575A10.5 10.5 0 0110.5 13.5h3.003a10.44 10.44 0 017.782 3.503 1.5 1.5 0 11-2.242 1.994 7.441 7.441 0 00-5.544-2.497H10.5a7.5 7.5 0 000 15h2.998a7.45 7.45 0 005.545-2.497 1.5 1.5 0 112.242 1.994 10.447 10.447 0 01-7.781 3.503H10.5a10.5 10.5 0 01-7.425-17.925zM12 23.998a1.5 1.5 0 011.5-1.5h21a1.5 1.5 0 010 3h-21a1.5 1.5 0 01-1.5-1.5z"}));
}

Link.defaultProps = {"viewBox":"0 0 48 48"};

module.exports = Link;

Link.default = Link;
